module.exports = __webpack_public_path__ + "img/int.244a1097.png";